<template>
  <div class="main">
    <div class="content">
      <div class="left">
        <div class="title">
          <img src="./images/ic_launcher@3x.png" alt="" />
        </div>
        <div class="title2">
          <img src="./images/title_text@x.png" alt="" />
        </div>
        <div class="download">
          <div class="download-btn">
            <div class="android-btn" @click="showToast">
              <img src="./images/_s-anzhuo@3x.png" alt="" />
              <p>安卓下载</p>
            </div>
            <div class="android-btn"  @click="showToast">
              <img src="./images/_s-ios@3x.png" alt="" />
              <p>iOS下载</p>
            </div>
          </div>
          <div class="qr">
            <div ref="qrcodeTop" id="qrcode"></div>
            <p>手机扫一扫下载</p>
          </div>
        </div>
      </div>
      <div class="right">
        <van-swipe class="my-swipe" :autoplay="3000" :show-indicators="false">
          <van-swipe-item
            ><img src="./images/bg1@3x.png" alt=""
          /></van-swipe-item>
          <van-swipe-item
            ><img src="./images/bg2@3x.png" alt=""
          /></van-swipe-item>
          <van-swipe-item
            ><img src="./images/bg3@3x.png" alt=""
          /></van-swipe-item>
        </van-swipe>
      </div>
    </div>
    <div class="toasta" v-show="isShowToast">请使用手机扫一扫下载</div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      isShowToast: false
    }
  },
  created() {
    this.$nextTick(() => {
      this.createQrcode()
    })
    // 埋点
    this.$sensors.track('LandingPage', {
      method: 'view',
      ldy_type: 'PC'
    });
  },
  mounted() {
    var _paq = window._paq = window._paq || [];
    let code = this.getUrlParam("code");
    _paq.push(['setCustomDimension', 1, '9']);
    _paq.push(['setCustomDimension', 2, code]);
    _paq.push(['trackEvent',
      '框架加载',
      document.title,          //果酱...
      window.location.host]);
  },
  methods: {
    // 获取code参数
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
     createQrcode () {
      const that = this
      const url = window.location.href
      new QRCode(that.$refs.qrcodeTop, {
        text: url,
        width: 249,
        height: 260,
        colorDark: '#000000',
        colorLight: '#ffffff'
      })
    },
    showToast() {
      this.isShowToast = true
      setTimeout(() => {
        this.isShowToast = false
      }, 3000);
      // this.$toast({
      //   message: '请使用手机扫一扫下载',
      //   position: 'top',
      // });
      this.$sensors.track('LandingPage', {
      method: 'download',
      ldy_type: 'PC',
      pid: 'M19'
    });
    }
  },
};
</script>

<style lang="scss" scoped>
.main {
  min-width: 1300px;
  min-height: 100vh;
  height: auto;
  background: url("./images/_s-bj@3x.png") no-repeat center center fixed;
  background-size: cover;
  overflow: hidden;
  .toasta {
    width: 200px;
    height: 40px;
    position: absolute;
    bottom: 0;
    top: 50%;
    left: 50%;
    right: 50%;
    background-color: #ffffff;
    text-align: center;
    line-height: 40px;
    color: #0e0d0d;
    font-weight: 700;
    border-radius: 5px;
  }
  .content {
    width: 1300px;
    margin: 80px auto;
    display: flex;
    justify-content: center;
    .left {
      .title {
        margin-bottom: 25px;
        > img {
        width: 535px;
        }
      }
      .title2 {
        width: 650px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .download {
        display: flex;
        justify-content:space-around;
        align-items: center;
        margin-top: 20px;
        .download-btn {
          margin-bottom: 15px;
        }
        .android-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 250px;
          height: 91px;
          background-color: rgba(0, 0, 0, 0.5);
          border: 2px solid;
          border-color: #ffffff;
          border-radius: 46px;
          color: #ffffff;
          font-size: 30px;
          margin-top: 35px;
          img {
            width: 60px;
            height: 60px;
          }
        }
        .qr {
          width: 249px;
          height: 282px;
          background-color: #ffffff;
          border-radius: 20px;
          padding: 15px;
          color: #8c8788;
        text-align: center;
          p {
            margin-top: 5px;
            font-size: 18px;
            color: #292023;
          }
        }
      }
    }
    .right {
      width: 600px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
